import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { tokens } from "../../theme";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import Header from "../../components/Header";
import StatBox from "../../components/StatBox";
import { use, useContext, useEffect, useState } from "react";
import MenuItemMui from "@mui/material/MenuItem";
import {
  ArrowDownward,
  CalendarMonth,
  Cancel,
  FactCheck,
  PictureAsPdf,
  RestartAlt,
  SimCardAlert,
  Today,
  VerifiedUser,
} from "@mui/icons-material";
import { DATA_SAVE_URL, MONTH_NAMES } from "../utils/UrlHandle";
import axios from "axios";
import IncomeExpenseChart from "../dashboardCharts/IncomeExpenseChart";
import AssignedJobsByUser from "../dashboardCharts/AssignedJobsByUser";
import timezone from "dayjs/plugin/timezone";
import StatBoxCustom from "../../components/StatBoxCustom";
import dayjs, { utc } from "dayjs";
import TestsDoneByYear from "../dashboardCharts/TestsDoneByYear";
import { getPayload } from "../../services/api";
import ConcreteCubesToBeCasted from "../dashboardCharts/ConcreteCubesToBeCasted";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import PDFViewerDialog from "../jasperReports/PDFViewerDialog";
import LoadingBackDrop from "../global/LoadingBackDrop";
// dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");
const Dashboard = ({
  setUserNotification,
  setNotificationCount,
  refreshDashboard,
  loggedUser,
  onLogout,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [assignJobs, setAssignJobs] = useState([]);
  const [allTestDone, setAllTestDone] = useState([]);
  const [viewIncomeCustom, setViewIncomeCustom] = useState(true);
  const [year, setYear] = useState([
    { id: 1, label: "2025", value: "2025" },
    { id: 2, label: "2026", value: "2026" },
  ]);
  const [currentYear, setCurrentYear] = useState(2026);
  const [mainData, setMainData] = useState({
    pendingJobs: 0,
    completedJobs: 0,
    dailyIncome: 0,
    monthlyIncome: 0,
    pendingJobsList: [],
    listIncomeOnly: [],
    listExpenseOnly: [],
    listProfit: [],
    profit: "0",
  });
  const [selectedRequestId, setSelectedRequestId] = useState({});
  const [openLabSheetDialog, setOpenLabSheetDialog] = useState(false);
  const [dateFrom, setDateFrom] = useState(dayjs(new Date()));
  const [dateTo, setDateTo] = useState(dayjs(new Date()));
  const [loading, setLoading] = useState(false);
  const [incomeByPeriod, setIncomeByPeriod] = useState(0.0);
  const [testingDate, settestingDate] = useState(
    dayjs(new Date()).tz("Asia/Colombo", true)
  );

  const handleCloseLabsheet = () => {
    setOpenLabSheetDialog(false);
  };

  // useEffect(() => {
  //   const validateToken = async () => {
  //     try {
  //       // Make a simple API call to validate token
  //       await getPayload.getPayloadData("/auth/validate"); // You might need to create this endpoint
  //     } catch (error) {
  //       if (error.response?.status === 401) {
  //         onLogout(); // Call logout if token is invalid
  //       }
  //     }
  //   };

  //   validateToken();
  // }, []);

  const [castingCubesData, setCastingCubesData] = useState([]);

  useEffect(() => {
    loadBasicData("2026");
    return () => loadBasicData("2026");
  }, [refreshDashboard]);

  const loadBasicData = async (val) => {
    try {
      // const response = await axios.get(
      //   DATA_SAVE_URL + "/api/v1/dashboard/" + loggedUser.id
      // );

      // const response = await authAPI.login({
      //         userName: formData.userName, // Assuming your backend expects 'email' field
      //         password: formData.password,
      //       });
      setLoading(true);
      const response = await getPayload.getPayloadData(
        `/dashboard/data?userId=${loggedUser.id}&testDate=${testingDate.format(
          "YYYY-MM-DD"
        )}&year=${val}`
      );

      console.log("dash", response.data);
      // Use the response data directly instead of relying on mainData
      const arrayIncome = response.data.listIncomeOnly;
      const arrayExpense = response.data.listExpenseOnly;
      // console.log("arrinc ", arrayIncome);
      // console.log("arrincex ", arrayExpense);
      const arrayProfit = arrayIncome.map(
        (value, index) => value - arrayExpense[index]
      );
      setUserNotification(response.data.userNotifications);
      setNotificationCount((pre) => response.data.notificationCount);
      // console.log("arrpro ", arrayProfit);
      const totalProfit = arrayProfit.reduce((accumulator, currentValue) => {
        return accumulator + currentValue;
      }, 0);
      setAssignJobs(response.data.allLabRequestTests);
      setAllTestDone(response.data.allTestsByCategory);
      // Update state with all changes at once
      setMainData((prev) => ({
        ...response.data, // Spread all the response data
        listProfit: arrayProfit, // Add the calculated profit array
        profit: totalProfit,
      }));
      setCastingCubesData(response.data.allCastingCubes);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getIncomeByPeriod = async () => {
    try {
      const response = await axios.get(
        DATA_SAVE_URL + "/api/v1/dashboard/incomePeriod",
        {
          params: {
            dateFrom: dateFrom.format("YYYY-MM-DD"),
            dateTo: dateTo.format("YYYY-MM-DD"),
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // console.log("dash", response.data);
      // Use the response data directly instead of relying on mainData
      setIncomeByPeriod(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  return (
    <Box m="20px" ml="100px">
      {/* HEADER */}
      {loading ? <LoadingBackDrop openBackDrop={loading} /> : ""}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="DASHBOARD" subtitle="Welcome to your dashboard" />
        <TextField
          select
          label="Select year"
          size="small"
          value={currentYear}
          onChange={(e) => {
            setCurrentYear(e.target.value);
            loadBasicData(e.target.value);
          }}
          sx={{
            marginBottom: "5px",
            marginTop: "8px",
            gridColumn: "span 2",

            width: "150px",
          }}
        >
          {year?.map((option) => (
            <MenuItemMui key={option.id} value={option.value}>
              {option.value}
            </MenuItemMui>
          ))}
        </TextField>
      </Box>

      {/* GRID & CHARTS */}
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="200px"
        gap="20px"
      >
        {/* ROW 1 */}
        <Box
          gridColumn="span 3"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={mainData.pendingJobs}
            subtitle="Pending Jobs"
            progress="0.75"
            increase="+14%"
            showButton={false}
            icon={
              <SimCardAlert
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 3"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={mainData.completedJobs}
            showButton={false}
            subtitle="Completed Jobs"
            progress="0.50"
            increase="+21%"
            icon={
              <FactCheck
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 3"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {viewIncomeCustom ? (
            <StatBoxCustom
              title={
                "LKR " +
                incomeByPeriod?.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }
              subtitle={"Income : LKR " + "10,000.00"}
              progress="0.80"
              increase="+43%"
              setViewIncomeCustom={setViewIncomeCustom}
              viewIncomeCustom={viewIncomeCustom}
              dateFrom={dateFrom}
              dateTo={dateTo}
              setDateFrom={setDateFrom}
              setDateTo={setDateTo}
              getIncomeByPeriod={getIncomeByPeriod}
              icon={
                <Today
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          ) : (
            <StatBox
              title={
                "LKR " +
                mainData.dailyIncome.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }
              showButton={true}
              subtitle={"Daily Income  " + formattedDate}
              progress="0.80"
              increase="+43%"
              setViewIncomeCustom={setViewIncomeCustom}
              viewIncomeCustom={viewIncomeCustom}
              icon={
                <Today
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          )}

          {/* <StatBox
            title={
              "LKR " +
              mainData.dailyIncome.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            }
            subtitle={"Daily Income  " + formattedDate}
            progress="0.80"
            increase="+43%"
            icon={
              <Today
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          /> */}
        </Box>
        <Box
          gridColumn="span 3"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title={
              "LKR " +
              mainData.income?.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            }
            showButton={false}
            subtitle={"Income - " + [new Date().getFullYear()]}
            progress="0.80"
            increase="+43%"
            icon={
              <CalendarMonth
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>

        {/* ROW 2 */}
        <Box
          gridColumn="span 12"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
        >
          <Box
            mt="25px"
            p="0 30px"
            display="flex "
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Box display="flex" alignItems="baseline" gap={1}>
                <Typography
                  variant="h4"
                  fontWeight="600"
                  color={colors.grey[400]}
                >
                  {"Income And Expenses of " + today.getFullYear()}
                </Typography>
                <Typography variant="subtitle1" color="error">
                  [All figures are in LKR]
                </Typography>
              </Box>
              <Typography
                variant="h2"
                sx={{ marginBottom: "15px" }}
                fontWeight="bold"
                color={colors.grey[600]}
              >
                {"Annual Profit : " +
                  mainData.profit?.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </Typography>
            </Box>
            <Box>
              <IconButton>
                <DownloadOutlinedIcon
                  sx={{ fontSize: "26px", color: colors.greenAccent[500] }}
                />
              </IconButton>
            </Box>
          </Box>
          <Box height="250px" m="-20px 0 0 20px">
            {/* <LineChart isDashboard={true} /> */}
            <IncomeExpenseChart
              listIncomeOnly={mainData.listIncomeOnly}
              listExpenseOnly={mainData.listExpenseOnly}
              listProfit={mainData.listProfit}
            />
          </Box>
        </Box>

        {/* ROW 3 */}
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          p="30px"
        >
          <Typography variant="h5" fontWeight="600">
            Assigned Reports TO / ATO
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mt="35px"
          >
            {/* <ProgressCircle size="125" />
            <Typography
              variant="h5"
              color={colors.greenAccent[500]}
              sx={{ mt: "15px" }}
            >
              76 % completed of pending tests
            </Typography>
            <Typography>Includes all paid & non paid tests</Typography> */}
            <AssignedJobsByUser labRequestTests={assignJobs} />
          </Box>
        </Box>
        <Box
          gridColumn="span 8"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          padding="10px"
          sx={{ overflow: "auto" }}
        >
          <Typography
            variant="h5"
            fontWeight="600"
            sx={{ padding: "30px 30px 0 30px" }}
          >
            Concrete cube tests to be done
          </Typography>
          <Box
            display="flex"
            gap={1}
            sx={{ paddingLeft: "30px", paddingBottom: "10px" }}
          >
            <Button
              startIcon={<RestartAlt />}
              variant="contained"
              color="info"
              size="medium"
              sx={{ marginTop: "8px" }}
              onClick={() => loadBasicData("2026")}
            >
              REFRESH
            </Button>
          </Box>

          <Box height="250px" justifyItems="center">
            {/* <BarChart isDashboard={true} /> */}
            {/* <BarChartMui /> */}
            {/* <TestsDoneByYear allTestDone={allTestDone} /> */}
            <ConcreteCubesToBeCasted
              setOpenLabSheetDialog={setOpenLabSheetDialog}
              setSelectedRequestId={setSelectedRequestId}
              castingCubesData={castingCubesData}
            />
          </Box>
        </Box>
      </Box>

      <PDFViewerDialog
        reportNo={`CUBE_TEST_${selectedRequestId?.id}_${
          selectedRequestId.labRequest?.year
        }_${String(selectedRequestId?.id).padStart(4, "0")}`}
        labRequestId={selectedRequestId?.id}
        open={openLabSheetDialog}
        handleCloseReportPreview={handleCloseLabsheet}
        letterHead={""}
        jobId={selectedRequestId?.id} //this is selected test id
        reportType={"LABSHEET"}
      />
    </Box>
  );
};

export default Dashboard;
